import {
    AUTH_SIGNUP_REQUEST,
    AUTH_SIGNUP_SUCCESS,
    AUTH_SIGNUP_FAIL,
    AUTH_SIGNUP_RESET,
    AUTH_SIGNIN_REQUEST,
    AUTH_SIGNIN_SUCCESS,
    AUTH_SIGNIN_FAIL,
    AUTH_PAYMENT_METHOD_REQUEST,
    AUTH_PAYMENT_METHOD_SUCCESS,
    AUTH_PAYMENT_METHOD_FAIL,
    AUTH_PAYMENT_METHOD_RESET,
  } from "../constants/authPaymentConstants";
  
  // Reducer for signup
  export const authSignupReducer = (state = {}, action) => {
    switch (action.type) {
      case AUTH_SIGNUP_REQUEST:
        return { loading: true };
      case AUTH_SIGNUP_SUCCESS:
        return { loading: false, userInfo: action.payload };
      case AUTH_SIGNUP_FAIL:
        return { loading: false, error: action.payload };
      case AUTH_SIGNUP_RESET:
        return {};
      default:
        return state;
    }
  };
  
  // Reducer for signin
  export const authSigninReducer = (state = {}, action) => {
    switch (action.type) {
      case AUTH_SIGNIN_REQUEST:
        return { loading: true };
      case AUTH_SIGNIN_SUCCESS:
        return { loading: false, userInfo: action.payload };
      case AUTH_SIGNIN_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Reducer for payment method
  export const authPaymentMethodReducer = (state = {}, action) => {
    switch (action.type) {
      case AUTH_PAYMENT_METHOD_REQUEST:
        return { loading: true };
      case AUTH_PAYMENT_METHOD_SUCCESS:
        return { loading: false, paymentInfo: action.payload };
      case AUTH_PAYMENT_METHOD_FAIL:
        return { loading: false, error: action.payload };
      case AUTH_PAYMENT_METHOD_RESET:
        return {};
      default:
        return state;
    }
  };
  